<template>
  <el-row class="xh-esg-left">
    <el-col :span="24">
      <el-menu default-active="0" @select="handleSelect">
        <el-menu-item
          v-for="(item, index) in menus"
          :key="index"
          :index="index + ''"
        >
          <i class="xh-esg-menu-icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    menus: Array,
  },
  methods: {
    handleSelect(index) {
      this.$emit("select", index);
    },
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-left {
  /deep/ .el-menu {
    background-color: var(--comp_06);
    border-right: 1px solid var(--comp_06);
  }
  /deep/ .el-menu-item:focus,
  /deep/ .el-menu-item:hover {
    outline: 0;
    background-color: var(--comp_06);
  }
  .xh-esg-menu-icon {
    height: 8px;
    width: 8px;
    background-color: var(--comp_06);
    display: inline-block;
    margin-right: 8px;
  }
  .el-menu-item.is-active {
    .xh-esg-menu-icon {
      background-color: #008bce;
    }
  }
  /deep/ .el-menu-item {
    color: var(--font_01);
    border-bottom: 1px solid var(--comp_02);
  }
  /deep/ .el-menu-item:last-child {
    border-bottom: 1px solid var(--comp_06);
  }
  /deep/ .el-menu-item.is-active{
    color: #008BCE;

  }
}
</style>